<base-support-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="'btn-primary'" [btnOkLabel]="'Продлить'" (onOk)="ok()" >
	<div [formGroup]="form">
		<p>
			Номер счёта: <span class="badge badge-info">{{invoiceNumber}}</span>
			<br>
			Тариф: <span class="badge badge-info">{{tariffId.toUpperCase()}}</span>
		</p>

		<div class="alert alert-warning" *ngIf="recurrentProfile">Данный счёт имеет активную подписку № <span class="badge badge-warning">{{recurrentProfile}}</span></div>

		<div class="form-group">
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="periodType" id="periodType1" [(ngModel)]="periodType" [value]="1">
				<label class="form-check-label" for="periodType1">Действителен до</label>
			</div>
			<div>
				<datepicker formControlName="dateTo" [(ngModel)]="dateTo" [disabled]="periodType!=1"></datepicker>
			</div>
		</div>

		<div class="form-group">
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="periodType" id="periodType2" [(ngModel)]="periodType" [value]="2">
				<label class="form-check-label" for="periodType2">Продлить на</label>
			</div>
			<input type="number" formControlName="customDaysCount" [min]="minCustomDaysCount" [(ngModel)]="customDaysCount" [placeholder]="minCustomDaysCount" class="form-control" [disabled]="periodType!=2">
		</div>

		<div class="form-group">
			<div class="form-check">
				<input class="form-check-input" type="radio" [ngModelOptions]="{standalone: true}" name="periodType" id="periodType3" [(ngModel)]="periodType" [value]="3">
				<label class="form-check-label" for="periodType3">Оставить 10 дней тарифа</label>
			</div>
		</div>

		<div class="form-group" *ngIf="recurrentProfile">
			<div class="form-check">
				<input class="form-check-input" type="checkbox" [ngModelOptions]="{standalone: true}" name="renewRebillDate" id="renewRebillDate" [(ngModel)]="renewRebillDate">
				<label class="form-check-label" for="renewRebillDate">Перенести дату рекуррентного списания</label>
			</div>
		</div>
	</div>
</base-support-modal>

